module.exports = __webpack_public_path__ + "static/media/electric.36fec9d5.jpg";